module.exports = __webpack_public_path__ + "static/media/61.55d21925.jpg";